import { articles } from "./newsData";
import "./News.css";

const formatNewsDate = (dateStr) => {
  const date = new Date(dateStr);
  if (!dateStr || isNaN(date.getTime())) return "";
  const diffH = Math.floor((Date.now() - date) / 3600000);
  if (diffH < 1) return "À l'instant";
  if (diffH < 24) return `Il y a ${diffH}h`;
  return `Il y a ${Math.floor(diffH / 24)}j`;
};

function News({ onArticleClick }) {
  return (
    <section className="news-section">
      <div className="news-section-header">
        <span className="news-section-label">Actualités</span>
      </div>
      <div className="news-scroll">
        {articles.map((article, i) => (
          <button
            key={article.id}
            className="news-card"
            onClick={() => onArticleClick(article.id)}
            style={{ animationDelay: `${i * 50}ms` }}
          >
            <div className="news-card-img-wrap">
              {article.thumbnail
                ? <img className="news-card-img" src={article.thumbnail} alt="" loading="lazy" />
                : <div className="news-card-img-placeholder">⚽</div>
              }
              <span className="news-card-date">{formatNewsDate(article.pubDate)}</span>
            </div>
            <div className="news-card-body">
              <p className="news-card-category">{article.category}</p>
              <h3 className="news-card-title">{article.title}</h3>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}

export default News;
